import { Box, Typography } from '@material-ui/core';
import _ from 'lodash';
import { FunctionComponent, useMemo } from 'react';

import Modal from '../../../../../shared/modal';
import { WorkItem, WorkType } from '../../../../../types/work';
import { useStyles } from './styled';

type Props = {
    open: boolean;
    onClose: () => void;
    workType?: WorkType;
    work?: WorkItem;
};

const InstructionsModal: FunctionComponent<Props> = ({
    open,
    onClose,
    workType,
    work
}) => {
    const classes = useStyles();

    const title = useMemo(() => {
        const type = workType || work?.workType;
        if (!type) {
            return 'Instructions';
        }

        if (work?.workInput?.['associated_blocker_task_title']){
            return 'Resolve blocker';
        }

        if (type === WorkType.CODING && work?.taskType) {
            return work.taskType;
        }
        return _.startCase(_.toLower(WorkType[type]));
    }, [ workType, work ]);

    /* eslint-disable max-len */
    const instructions = useMemo(() => {
        const type = workType || work?.workType;
        const workInput = work?.workInput || {};

        if (workInput['associated_blocker_task_title']) {
            return 'Flow:\n1. Review the work description.\n2. Open the extension, review the instructions there.\n3. After submitting in the extension, you will see here a PR with a green "V".\n4. Add a "proof of work" that represents your work.\n5. Submit.';
        }

        if (type === WorkType.CODING && workInput['required_workflows']) {
            return 'Flow:\n1. Review the work description.\n2. Open the extension, review the instructions there.\n3. After submitting in the extension, you will see here a PR with a green "V".\n4.We will run the Github Workflows for your PRs. If they pass, you can submit your work. If they fail, you will see the feedback and can fix the issues and submit again.\n5. Add a "proof of work" that represents your work.\n6. Submit.';
        }
        
        switch (type) {
            case WorkType.CODING:
                return 'Flow:\n1. Review the work description.\n2. Open the extension, review the instructions there.\n3. After submitting in the extension, you will see here a PR with a green "V".\n4. Add a "proof of work" that represents your work.\n5. Submit.';

            case WorkType.RESOLVE_CONFLICTS:
                return 'Flow:\n1. Review the work description.\n2. Open the extension, review the instructions there.\n3. After submitting in the extension, you will see here a PR with a green "V".\n4. Submit.';
            
            case WorkType.QUEST_REVIEW:
                return 'Flow:\n1. Review the work description and pay attention to all attachments.\n2. Open the extension, review the instructions there.\n3. After submitting in the extension, you will see here a PR with a green "V".\n4. Add "proof of work".\n5. If you marked X (reject) in the extension, you will decide in the web app whether to resolve the open issues yourself or send the quest back for a new smart breakdown.\n6. Submit.';
            
            case WorkType.REVIEW_REQUEST_REJECTION:
                return 'Flow:\n1. Review the description and the rejection reason, and pay attention to all attachments\n2. If needed, you can review the code via the extension for additional context.\n3. Decide whether to resolve the gaps by yourself or send the quest back for a new smart breakdown.\n4. Submit your work';

            case WorkType.PLANNING_QUESTIONS_ANSWERING:
                return 'Flow:\n1. Review the planning questions carefully.\n2. Answer each question by selecting the most relevant option or providing a free-text response.\n3. You may skip questions you\'re unsure about.\n4. Once all questions are answered, submit your answers.\n5. The system will process your answers and generate a plan. Once the plan is ready, submit the work item.';
            default:
                return 'Flow:\n1. Review the work description.\n2. Open the extension, review the instructions there.\n3. After submitting in the extension, you will see here a PR with a green "V".\n4. Add a "proof of work" that represents your work.\n5. Submit.';

        }
    }, [ workType, work ]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={`${title} Instructions`}
            hasCrossIcon
        >
            <Box p={2}>
                <Typography className={classes.text}>
                    {instructions}
                </Typography>
            </Box>
        </Modal>
    );
};

export default InstructionsModal;

